export default "__VITE_ASSET__BJmD15ql__"